import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

import { ReactComponent as BooleanSvg } from "@/svgs/boolean.svg?react";

export default function BooleanIcon(props: SvgIconProps) {
	return <SvgIcon {...props} component={BooleanSvg} inheritViewBox />;
}
